// @ts-nocheck
import { useEffect } from "react";
import { useFetch } from "../../Services/useFetch";

const CHECK_INTERVAL_MS = 30 * 1000;

// Asks the backend every 30s (and when the tab becomes visible again) whether
// the session is still valid, so a user set inactive (in DocGrid or HRMS) is
// logged out even when the open page makes no API calls. useFetch turns the
// backend's 401 into the logout.
export const useSessionWatch = (enabled) => {
  const { request } = useFetch();

  useEffect(() => {
    if (!enabled) return undefined;

    const check = () => {
      if (document.visibilityState === "visible" && localStorage.getItem("docGridToken")) {
        request("/session/check", "GET");
      }
    };

    const timer = setInterval(check, CHECK_INTERVAL_MS);
    document.addEventListener("visibilitychange", check);
    return () => {
      clearInterval(timer);
      document.removeEventListener("visibilitychange", check);
    };
  }, [enabled, request]);
};
